import React from 'react';

export default function Paragraph() {
  return (
    <React.Fragment>
      It's a Paragraph!
    </React.Fragment>
  );
}
